import { useTranslation } from "react-i18next";

import { COLUMN_RESOURCES, DROPDOWN_SIZES, ENDPOINTS, ID_TYPE } from "shared";

import QueryDropdown from ".";
import { QueryDropdownProps } from "./types";

const CompanyDropdown = ({
    ...props
}: Omit<QueryDropdownProps, "resource" | "idType" | "size">) => {
    const { t } = useTranslation();

    return (
        <QueryDropdown
            {...props}
            resource={ENDPOINTS.Companies}
            idType={ID_TYPE.Id}
            size={DROPDOWN_SIZES.Medium}
            fullWidth
            labelLeft={props.labelLeft ?? t("Dialog##company")}
            textFieldParams={
                props.textFieldParams ?? { placeholder: t("Dialog##select") }
            }
            description={[
                {
                    resource: COLUMN_RESOURCES.Id,
                    name: t("General##id")
                },
                {
                    resource: COLUMN_RESOURCES.Code,
                    name: t("Table##code")
                }
            ]}
        />
    );
};

export default CompanyDropdown;
